module.exports = __webpack_public_path__ + "static/media/multidimensional-img2x.f18b9bc4.png";